import { Box } from 'components/Box';
import { Icon } from 'components/Icon/Icon';
import FlagListingContainer from 'containers/FlagListingContainer';
import { ListingType } from 'types/ListingType';

import { StyledDropdownItem } from './ListingActionsDropdown.styled';

type Props = {
  closeMenu: () => void;
  listingId: string;
  listingType: ListingType;
};

export function ReportListingMenuItem({
  closeMenu,
  listingId,
  listingType,
}: Props) {
  return (
    <FlagListingContainer
      listingId={listingId}
      listingType={listingType}
      render={({ flagListing }) => (
        <StyledDropdownItem
          data-qa-id="flag-content"
          onClick={(e) => {
            e.preventDefault();
            flagListing();
            closeMenu();
          }}
        >
          <Box mr="10px">
            <Icon name="flag" size={16} />
          </Box>
          {getText('Report This Listing')}
        </StyledDropdownItem>
      )}
    />
  );
}
